import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { SectionHeader } from "./SectionHeader";

export function HorizontalScrollSection({
  title,
  hint,
  to,
  children,
}: {
  title: string;
  hint?: string;
  to?: string;
  children: ReactNode;
}) {
  return (
    <section className="min-w-0">
      <SectionHeader title={title} hint={hint} to={to} />
      <div className="scroll-row pb-1">{children}</div>
    </section>
  );
}

export function ScrollCard({ children, className = "" }: { children: ReactNode; className?: string }) {
  return (
    <div className={`w-[72vw] max-w-[280px] sm:w-64 lg:w-56 ${className}`}>{children}</div>
  );
}

export function SeeAllLink({ to, label = "See all" }: { to: string; label?: string }) {
  return (
    <Link to={to} className="text-[11px] font-semibold text-brand-pink">
      {label} →
    </Link>
  );
}
